import React from "react";

const SaveAsDraftSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M22.5144 7.54814L18.4519 3.48564C18.376 3.41033 18.2859 3.35076 18.1869 3.31032C18.0879 3.26989 17.9819 3.2494 17.875 3.25001H4.875C4.44402 3.25001 4.0307 3.42122 3.72595 3.72596C3.4212 4.03071 3.25 4.44404 3.25 4.87501V21.125C3.25 21.556 3.4212 21.9693 3.72595 22.2741C4.0307 22.5788 4.44402 22.75 4.875 22.75H21.125C21.556 22.75 21.9693 22.5788 22.274 22.2741C22.5788 21.9693 22.75 21.556 22.75 21.125V8.12501C22.7506 8.01808 22.7301 7.91208 22.6897 7.81309C22.6493 7.7141 22.5897 7.62406 22.5144 7.54814ZM9.75 4.87501H16.25V8.12501H9.75V4.87501ZM16.25 21.125H9.75V14.625H16.25V21.125ZM17.875 21.125V14.625C17.875 14.194 17.7038 13.7807 17.399 13.476C17.0943 13.1712 16.681 13 16.25 13H9.75C9.31902 13 8.9057 13.1712 8.60095 13.476C8.2962 13.7807 8.125 14.194 8.125 14.625V21.125H4.875V4.87501H8.125V8.12501C8.125 8.55599 8.2962 8.96931 8.60095 9.27406C8.9057 9.57881 9.31902 9.75001 9.75 9.75001H16.25C16.681 9.75001 17.0943 9.57881 17.399 9.27406C17.7038 8.96931 17.875 8.55599 17.875 8.12501V5.20814L21.125 8.45814V21.125H17.875Z"
        fill="black"
      />
    </svg>
  );
};

export default SaveAsDraftSvg;
